import { asyncComponentFactory } from '@utils';

const AppComponents = {
  // UI Components ------------------------------------------------------------
  Accordion: asyncComponentFactory('ui/Accordion'),
  BuildGallerySlider: asyncComponentFactory('ui/BuildGallerySlider'),
  ImageComparison: asyncComponentFactory('ui/ImageComparison'),
  IndexedContent: asyncComponentFactory('ui/IndexedContent'),
  Drawer: asyncComponentFactory('ui/Drawer'),
  // Dropdown: asyncComponentFactory('ui/Dropdown'),
  // Dropdown: asyncComponentFactory('ui/Dropdown'),
  // QuickSearch: asyncComponentFactory('ui/QuickSearch'),
  // Modal: asyncComponentFactory('ui/Modal'),
  MainNav: asyncComponentFactory('ui/MainNav'),
  MiniCart: asyncComponentFactory('ui/MiniCart'),
  ProductGallery: asyncComponentFactory('ui/ProductGallery'),
  Slider: asyncComponentFactory('ui/Slider'),
  Tabs: asyncComponentFactory('ui/Tabs'),
  // Footer: asyncComponentFactory('ui/Footer'),
  VariantSelector: asyncComponentFactory('ui/VariantSelector'),
  // MEDIA Components ------------------------------------------------------------
  // VideoPlayer: asyncComponentFactory('media/VideoPlayer'),
};

export default AppComponents;
